export default "__VITE_ASSET__BuYTi_B$__"